import type { ReactElement } from 'react';
import {
  dedupeByPlatformLabel,
  PlatformBadge,
} from '@/components/shared/platform';

interface MCPSourceBadgesProps {
  sources: string[];
}

/**
 * Component for displaying a list of MCP source badges (Cursor, Claude, Copilot, VS Code)
 * Uses the shared PlatformBadge component with proper icons
 */
export function MCPSourceBadges({
  sources,
}: MCPSourceBadgesProps): ReactElement {
  return (
    <div className="flex gap-1 flex-wrap">
      {dedupeByPlatformLabel(sources).map(source => (
        <PlatformBadge key={source} platform={source} showTooltip={false} />
      ))}
    </div>
  );
}
